import { render, staticRenderFns } from "./AddEditWorkShifts.vue?vue&type=template&id=2fa12eff&scoped=true"
import script from "./AddEditWorkShifts.vue?vue&type=script&lang=js"
export * from "./AddEditWorkShifts.vue?vue&type=script&lang=js"
import style0 from "./AddEditWorkShifts.vue?vue&type=style&index=0&id=2fa12eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa12eff",
  null
  
)

export default component.exports